import ExcelJS from 'exceljs';
import { IColumnDinamico } from '../../../shared/interfaces/database/tramites_automaticos';

export function getColumnAlignment(column: IColumnDinamico): string {
  switch (column.dataType) {
    case ExcelJS.ValueType.Date:
      return 'text-center';
    case ExcelJS.ValueType.Number:
      // MONEY
      if (column.format && /[$€£¥]/.test(column.format)) {
        return 'text-right';
      }
      return 'text-center';
    default:
      return 'text-left';
  }
}